export default __webpack_public_path__ + "static/media/image4.024b77fd.png";